import { render, staticRenderFns } from "./AddStudentModal.vue?vue&type=template&id=40444eaf&"
import script from "./AddStudentModal.vue?vue&type=script&lang=js&"
export * from "./AddStudentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports